import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { isEmpty, isNil } from '@/utils/misc';

export interface License {
  license?: string;
  licenseUrl: string;
}

export interface AttributionItem {
  name: string;
  licenses: License[];
  url: string;
  version: string;
  authors: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AttributionsList',
  props: {
    attributions: null
  },
  setup(__props: any) {



const { t } = useI18n();

function hasAuthors(item: AttributionItem): boolean {
  return !isEmpty(item.authors);
}

function parseAuthors(authors: string[]): string {
  return authors.join(', ');
}

function hasLicense(item: AttributionItem): boolean {
  return !isEmpty(item.licenses);
}

function hasLicenseName(item: AttributionItem): boolean {
  return !isNil(item.licenses[0].license);
}

function hasOneLicense(item: AttributionItem): boolean {
  return item.licenses.length === 1;
}

return { __sfc: true,t, hasAuthors, parseAuthors, hasLicense, hasLicenseName, hasOneLicense, isEmpty }
}

})